import { z } from "zod";

export const RiskSchema = z.object({
    id: z.number().optional(),
    riskDescription: z.string().min(1, "Risk Description is required"),
    currentStatus: z.string().min(1, "Current Status is required"),
    riskOwnerPerson: z.string().min(1, "Risk Owner (Person) is required"),
    riskOwnerUnit: z.string().min(1, "Risk Owner (Unit) is required"),
    riskOwnerTeam: z.string().min(1, "Risk Owner (Team) is required"),
    riskMethod: z.string().min(1, "Risk Method is required"),
    selectedAsset: z.string().optional(),
    selectedProcess: z.string().optional(),
    selectedCategory: z.string().optional(),
    riskRealisation: z.string().min(1, "In case of Risk Realisation is required"),
    riskStatus: z.string().optional(),
    impactRating: z.number().optional(),
    riskValue: z.union([z.string(), z.number()]).optional(),
    riskImprovementMethod: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
});

export const RiskFormSchema = z.object({
    riskDescription: z.string().min(1, "Risk Description is required"),
    currentStatus: z.string().min(1, "Current Status is required"),
    riskOwnerPerson: z.string().min(1, "Risk Owner (Person) is required"),
    riskOwnerUnit: z.string().min(1, "Risk Owner (Unit) is required"),
    riskOwnerTeam: z.string().min(1, "Risk Owner (Team) is required"),
    riskMethod: z.string().min(1, "Risk Method is required"),
    selectedAsset: z.string().optional(),
    selectedProcess: z.string().optional(),
    selectedCategory: z.string().optional(),
    riskRealisation: z.string().min(1, "In case of Risk Realisation is required"),
});

export const CreateRiskSchema = RiskSchema.omit({ id: true });
export const UpdateRiskSchema = RiskSchema;